import { AudioElementEventProps, AudioElementNativeProps } from '../types'

export const initializeAudioPlayer = (
  {
    src,
    loop = false,
    volume = 0.75,
    muted = false,
    crossOrigin = null,
    preload = '',
    playbackRate = 1.0,
    autoplay = false,
  }: AudioElementNativeProps,
  {
    onabort = null,
    oncanplay = null,
    oncanplaythrough = null,
    ondurationchange = null,
    onemptied = null,
    onended = null,
    onerror = null,
    onloadeddata = null,
    onloadedmetadata = null,
    onloadstart = null,
    onpause = null,
    onplay = null,
    onplaying = null,
    onprogress = null,
    onratechange = null,
    onseeked = null,
    onseeking = null,
    onstalled = null,
    onsuspend = null,
    ontimeupdate = null,
    onvolumechange = null,
    onwaiting = null,
  }: Partial<AudioElementEventProps>,
  existingAudio?: HTMLAudioElement
) => {
  if (!src) {
    console.error('No audio source provided')
    return undefined
  }

  // 🔹 reuse existing audio instead of creating new
  const audio = existingAudio ?? new Audio()

  audio.src = src
  audio.volume = volume
  audio.loop = loop
  audio.muted = muted
  audio.autoplay = autoplay
  audio.crossOrigin = crossOrigin
  audio.preload = preload
  audio.playbackRate = playbackRate

  audio.onabort = onabort
  audio.oncanplay = oncanplay
  audio.oncanplaythrough = oncanplaythrough
  audio.ondurationchange = ondurationchange
  audio.onemptied = onemptied
  audio.onended = onended
  audio.onerror = onerror
  audio.onloadeddata = onloadeddata
  audio.onloadedmetadata = onloadedmetadata
  audio.onloadstart = onloadstart
  audio.onpause = onpause
  audio.onplay = onplay
  audio.onplaying = onplaying
  audio.onprogress = onprogress
  audio.onratechange = onratechange
  audio.onseeked = onseeked
  audio.onseeking = onseeking
  audio.onstalled = onstalled
  audio.onsuspend = onsuspend
  audio.ontimeupdate = ontimeupdate
  audio.onvolumechange = onvolumechange
  audio.onwaiting = onwaiting

  return audio
}
